// extracted by mini-css-extract-plugin
export default {"container":"styles_container__A5Voy","userContainer":"styles_userContainer__RdsOR","avatar":"styles_avatar__cu-hS","userName":"styles_userName__Vf2az"};